import { render, staticRenderFns } from "./pip.vue?vue&type=template&id=913a3df0"
import script from "./pip.vue?vue&type=script&lang=js"
export * from "./pip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports